import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=5820a550&"
import script from "./CellRendererActions.vue?vue&type=script&lang=js&"
export * from "./CellRendererActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports